/* User defined models */
import { Slot } from "./Slot.model";

export class Hold {
  id?: string;
  uri?: string;
  expirationDateTime?: any;
  slot?: Slot;
  candidateTimezoneOffset?: number;
  legacy?: any;

  constructor(
    id?: string,
    uri?: string,
    expirationDateTime?: any,
    slot?: Slot,
    candidateTimezoneOffset?: any,
    legacy?: any
  ) {
    this.id = id;
    this.uri = uri;
    this.expirationDateTime = expirationDateTime;
    this.slot = slot;
    this.candidateTimezoneOffset = candidateTimezoneOffset;
    this.legacy = legacy;
  }

  static convertAPIObjectToHold(rItem: any): Hold {
    let offset;

    if (!!rItem.candidateTimezoneOffset) {
      offset = +rItem.candidateTimezoneOffset.split(':')[0];

      if (rItem.candidateTimezoneOffset.includes('-')) {
        offset -= (+rItem.candidateTimezoneOffset.split(':')[1]) / 60;
      } else {
        offset += (+rItem.candidateTimezoneOffset.split(':')[1]) / 60;
      }
    }

    return new Hold(
      rItem.id,
      rItem.href,
      rItem.expirationDateTime,
      rItem.slot,
      offset,
      rItem.legacy
    );
  }
}